<template>
	<div class="food-truck-banner">
		<div class="info">
			<h2>Food Truck</h2>
			<p>No te quedes con la duda también podemos asesorarte sobre todos los modelos food trucks MACTRAIL.</p>
			<router-link tag="a" to="/contacto" class="btn btn-secondary text-white">Contactános</router-link>
		</div>
		<div class="img"></div>
	</div>
</template>
<script>
export default {}
</script>
<style scoped>
.food-truck-banner {
	width: 100%;
	background-color: #000;
	position: relative;
	padding: 24px;
	margin-top: 76px;
}
.food-truck-banner .img {
	width: 248px;
	height: 248px;
	background-image: url('~@/assets/img/food-truck.png');
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	right: 0px;
	top: -118px;
}
.info {
	width: 100%;
	margin-top: 85px;
}
h2 {
	font-weight: 600;
	color: #fff;
}
p {
	font-size: 18px;
	color: #fff;
}
@media (min-width: 991px) {
	.food-truck-banner .img {
		width: 330px;
		height: 330px;
		top: -157px;
	}
	.info {
		width: calc(100% - 340px);
		margin-top: 0px;
	}
}
</style>
